import { getAccessToken, withAccessToken, getCurrentUserId, hasActiveSession } from './functions/session';

const auth0CoreStrategy = {
  getAccessToken,
  withAccessToken,
  getCurrentUserId,
  hasActiveSession,
};

export { auth0CoreStrategy };
